import {Component, OnInit} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {PrenotazioneAppuntamentoService} from "../../services/prenotazione-appuntamento.service";
import {Appuntamento} from "../../models/appuntamento";
import {FormBuilder, Validators} from "@angular/forms";
import {AmministrazioneService} from "../../services/amministrazione.service";
import {UserData} from "../../models/user-data";
import {JoyrideService} from 'ngx-joyride';
import {format, zonedTimeToUtc} from "date-fns-tz";
import {parse} from "date-fns";
import {SubscriptionManager} from "../../shared/subscription-manager/subscription-manager.class";
import {ValidatorsPersonaFisica} from "../../shared/validators/validators-persona-fisica.component";
import {AlertService} from "../../shared/alert/alert.service";
import {of, switchMap} from "rxjs";
import { ConfigurazioneGeneraleService } from '../../services/configurazione-generale.service';
import { AccountService } from '../../core/auth/account.service';

@Component({
  selector: 'jhi-inserimento-dati-prenotazione-admin',
  templateUrl: './inserimento-dati-prenotazione.component.html',
  styleUrls: ['./inserimento-dati-prenotazione.component.scss']
})

export class InserimentoDatiPrenotazioneComponent extends SubscriptionManager implements OnInit {
  appuntamento!: Appuntamento;
  formDatiRichiedente!: any;
  circleLoading = false;
  dateConv!: Date;
  codiceServizio: string | null = null;
  ufficio: string | null = null;
  userData?: UserData | null;
  public initDone: boolean = false; // da cambiare in loading con spinner


  get getNome() {
    return this.formDatiRichiedente.controls['appuntamento'].controls['dichiarante'].controls['nome'];
  };

  get getCognome() {
    return this.formDatiRichiedente.controls['appuntamento'].controls['dichiarante'].controls['cognome'];
  };

  get getEmailC() {
    return this.formDatiRichiedente.controls['appuntamento'].controls['email'];
  }

  get getCF() {
    return this.formDatiRichiedente.controls['appuntamento'].controls['dichiarante'].controls['cf'];
  }

  get getDataDiNascita() {
    return this.formDatiRichiedente.controls['appuntamento'].controls['dichiarante'].controls['dataNascita'];
  };

  get getNumTel() {
    return this.formDatiRichiedente.controls['appuntamento'].controls['tel'];
  }

  upper() {
    this.getCF.setValue(this.getCF.value.toUpperCase())
  }

  constructor(private alertService: AlertService, private joyrideService: JoyrideService, private fb: FormBuilder, public route: Router, private activatedRoute: ActivatedRoute, private prenota_service: PrenotazioneAppuntamentoService, private ammServ: AmministrazioneService, private configurazioneGeneraleService: ConfigurazioneGeneraleService, private accountService:AccountService) {
    super();
    this.initDone = false;
  }
  async getUser(): Promise<void>{
    return new Promise((resolve, reject) => {
      this.accountService.getLoggedUser().subscribe({
        next: (res) => {
          this.userData = res;
          resolve();
        },
        error:(err)=>{
          this.userData = null;
          resolve();
        }
      })
    } )
  }
  async ngOnInit(): Promise<void> {
    window.localStorage.removeItem('app');
    //this.userData = JSON.parse(<string>localStorage.getItem('userData'));
    await this.getUser();
    this.codiceServizio = this.activatedRoute.snapshot.queryParams["servizio"];
    this.ufficio = this.activatedRoute.snapshot.queryParams["ufficio"];
    window.scrollTo(0, 0);
    let app: Appuntamento | null = null;
    if (this.userData !== null){
      app = {
        dichiarante: this.userData,
        richiedente: this.userData
      };
    }
    if (app !== null && app.richiedente !== null) {
      this.appuntamento = app;
      if (app.dichiarante && app.richiedente && app.dichiarante.id === app.richiedente.id) {// per me

        this.dateConv = zonedTimeToUtc(parse(this.appuntamento.richiedente!.dataDiNascita!.toString(), "yyyy-MM-dd", new Date()), 'Europe/Rome');
        this.formDatiRichiedente = this.fb.group({
          appuntamento: this.fb.group({

            email: [this.appuntamento.richiedente?.email, [Validators.required, Validators.email]],
            tel: [this.appuntamento.richiedente?.tel, [Validators.required, Validators.minLength(2), Validators.pattern('[- +()0-9]+')]],

            dichiarante: this.fb.group({
              nome: [this.appuntamento.richiedente?.nome, [Validators.required, Validators.pattern(/^[a-z ,.'-]+$/i), Validators.maxLength(256), Validators.minLength(2)]],
              cognome: [this.appuntamento.richiedente?.cognome, [Validators.required, Validators.pattern(/^[a-z ,.'-]+$/i), Validators.maxLength(128), Validators.minLength(2)]],

              dataNascita: [format(this.dateConv, "yyyy-MM-dd"), [Validators.required]],
              cf: [this.appuntamento.richiedente?.cf, [Validators.required, ValidatorsPersonaFisica.checkCodiceFiscaleCompleto]],
            })
          })
        });
        if (this.appuntamento.tel && this.appuntamento.email) {
          this.getNumTel.setValue(this.appuntamento.tel);
          this.getEmailC.setValue(this.appuntamento.email);
        }
      } else if (app.richiedente && app.dichiarante && app.richiedente.id !== app.dichiarante.id) {
        this.formDatiRichiedente = this.fb.group({
          appuntamento: this.fb.group({

            email: [this.appuntamento.email, [Validators.required, Validators.email]],
            tel: [this.appuntamento.tel, [Validators.required, Validators.minLength(2), Validators.pattern('[- +()0-9]+')]],

            dichiarante: this.fb.group({
              nome: [this.appuntamento.dichiarante?.nome, [Validators.required, Validators.pattern(/^[a-z ,.'-]+$/i), Validators.maxLength(256), Validators.minLength(2)]],
              cognome: [this.appuntamento.dichiarante?.cognome, [Validators.required, Validators.pattern(/^[a-z ,.'-]+$/i), Validators.maxLength(128), Validators.minLength(2)]],
              dataNascita: [this.appuntamento.dichiarante?.dataDiNascita, [Validators.required]],
              cf: [this.appuntamento.dichiarante?.cf, [Validators.required, ValidatorsPersonaFisica.checkCodiceFiscaleCompleto]],
            })
          })
        });
      } else if (this.appuntamento.richiedente && !this.appuntamento?.dichiarante) {
        this.formDatiRichiedente = this.fb.group({
          appuntamento: this.fb.group({

            email: [this.appuntamento.richiedente.email, [Validators.required, Validators.email]],
            tel: [this.appuntamento.richiedente.tel, [Validators.required, Validators.minLength(2), Validators.pattern('[- +()0-9]+')]],

            dichiarante: this.fb.group({
              nome: ["", [Validators.required, Validators.pattern(/^[a-z ,.'-]+$/i), Validators.maxLength(256), Validators.minLength(2)]],
              cognome: ["", [Validators.required, Validators.pattern(/^[a-z ,.'-]+$/i), Validators.maxLength(128), Validators.minLength(2)]],
              dataNascita: ["", [Validators.required]],
              cf: ["", [Validators.required, ValidatorsPersonaFisica.checkCodiceFiscaleCompleto]],
            })
          })
        });
      }
      this.initDone = true;
    } else {
      //await this.route.navigate(['error'])
      this.formDatiRichiedente = this.fb.group({
        appuntamento: this.fb.group({

          email: [app?.email ? app.email : '', [Validators.required, Validators.email]],
          tel: [app?.tel ? app.tel : '', [Validators.required, Validators.minLength(2), Validators.pattern('[- +()0-9]+')]],

          dichiarante: this.fb.group({
            nome: [app?.dichiarante?.nome ? app.dichiarante.nome : "", [Validators.required, Validators.pattern(/^[a-z ,.'-]+$/i), Validators.maxLength(256), Validators.minLength(2)]],
            cognome: [app?.dichiarante?.cognome ? app.dichiarante.cognome : "", [Validators.required, Validators.pattern(/^[a-z ,.'-]+$/i), Validators.maxLength(128), Validators.minLength(2)]],
            dataNascita: [app?.dichiarante?.dataDiNascita ? app.dichiarante.dataDiNascita : "", [Validators.required]],
            cf: [app?.dichiarante?.cf ? app.dichiarante.cf : "", [Validators.required, ValidatorsPersonaFisica.checkCodiceFiscaleCompleto]],
          })
        })
      });
      this.initDone = true;
      console.warn(this.formDatiRichiedente);
      this.appuntamento = {
        dichiarante: null,
        richiedente: null
      }
    }
  }

  getLocalStorage(): Appuntamento | undefined {
    if (localStorage.getItem('app') !== null) {
      return JSON.parse(localStorage.getItem('app') || '{}');
    } else {
      return undefined;
    }
  }

  goToPrenotaNuovoAppuntamento():void{
    if(this.codiceServizio){
      void this.route.navigateByUrl('Appuntamenti/prenota-nuovo-appuntamento?servizio=' + this.codiceServizio + "&ufficio=" + <string>this.ufficio, {state: {isListaPrenotazioni: this.checkListaPrenotazioni()}}).then();
    }else{
      void this.route.navigate(['Appuntamenti/prenota-nuovo-appuntamento'], {state: {isListaPrenotazioni: this.checkListaPrenotazioni()}}).then();
    }
  }

  checkListaPrenotazioni():boolean{
    return <boolean>window.history.state.isListaPrenotazioni;
  }

  goToListaPrenotazioni():void{
    return void this.route.navigate(['Appuntamenti/lista-prenotazioni']).then();
  }

  goToHome():void{
    window.location.href = this.configurazioneGeneraleService.configurazione.linkHome;
  }


  async goBack(): Promise<void> {
    if (this.ufficio !== null && this.codiceServizio !== null && this.ufficio !== undefined && this.codiceServizio !== undefined) {
      await this.route.navigateByUrl("Servizi/NuovaIstanza?servizio="+this.codiceServizio);
    } else {
      this.goToHome();
    }
  }


  async goToSceltaServiziPrenotazione(): Promise<void> {
    this.circleLoading = true;
    if (this.appuntamento && this.appuntamento.dichiarante?.idLogin === this.appuntamento.richiedente?.idLogin && this.appuntamento.richiedente !== null) {
      this.appuntamento.email = this.getEmailC.value;
      this.appuntamento.tel = this.getNumTel.value;
      localStorage.setItem('app', JSON.stringify(this.appuntamento));
      if(this.codiceServizio){
        await this.route.navigateByUrl('Appuntamenti/scelta-servizi-prenotazione?servizio=' + this.codiceServizio + "&ufficio=" + <string>this.ufficio, {state: {isListaPrenotazioni: this.checkListaPrenotazioni()}});
      }else{
        await this.route.navigate(['Appuntamenti/scelta-servizi-prenotazione'], {state: {isListaPrenotazioni: this.checkListaPrenotazioni()}});
      }
    } else {
      if (this.formDatiRichiedente.valid) {

        this.appuntamento.dichiarante = {
          nome: this.getNome.value,
          cognome: this.getCognome.value,
          email: this.getEmailC.value,
          cf: this.getCF.value,
          dataDiNascita: this.getDataDiNascita.value,
          tel: this.getNumTel.value
        };


        let noErr = true;
        this.subs.sink = this.ammServ.ricercaCittadinoByCFAPI(<string>this.appuntamento!.dichiarante?.cf).pipe(
          switchMap((utenteRicercato: UserData) => {
            if (utenteRicercato?.id !== undefined) {
              this.appuntamento.dichiarante!.id = utenteRicercato.id;
              return of(null); // Nessuna richiesta HTTP da fare in questo caso
            } else {
              return this.ammServ.inserimentoUtenteAPI(<UserData>JSON.parse(JSON.stringify(this.appuntamento.dichiarante)));
            }
          })
        ).subscribe({
          next: (user) => {
            if (user !== null) {
              this.appuntamento.dichiarante = user;
            }
          },
          error: (err) => {
            noErr = false;
            localStorage.removeItem('app');
            this.circleLoading = false;
            if(err.error.codice === '03'){
              this.ammServ.inserimentoUtenteAPI(<UserData>JSON.parse(JSON.stringify(this.appuntamento.dichiarante))).subscribe({
                next: (user) => {
                  if (user !== null) {
                    this.appuntamento.dichiarante = user;
                    noErr = true;
                  }
                },
                complete: () => {
                  this.circleLoading = false;
                  if (noErr) {
                    this.appuntamento.email = this.getEmailC.value;
                    this.appuntamento.tel = this.getNumTel.value;
                    localStorage.setItem('app', JSON.stringify(this.appuntamento));
                    if(this.codiceServizio){
                       this.route.navigateByUrl('Appuntamenti/scelta-servizi-prenotazione?servizio=' + this.codiceServizio + "&ufficio=" + <string>this.ufficio, {state: {isListaPrenotazioni: this.checkListaPrenotazioni()}});
                    }else{
                       this.route.navigate(['Appuntamenti/scelta-servizi-prenotazione'], {state: {isListaPrenotazioni: this.checkListaPrenotazioni()}});
                    }
                  }
                }
              })
            }else{
              this.alertService.creaAlert(err.error.messaggio, "danger", "sticky", 5000, true);
            }
          },
          complete: () => {
            this.circleLoading = false;
            if (noErr) {
              this.appuntamento.email = this.getEmailC.value;
              this.appuntamento.tel = this.getNumTel.value;
              localStorage.setItem('app', JSON.stringify(this.appuntamento));
              if (this.codiceServizio) {
                 this.route.navigateByUrl('Appuntamenti/scelta-servizi-prenotazione?servizio=' + this.codiceServizio + "&ufficio=" + <string>this.ufficio, { state: { isListaPrenotazioni: this.checkListaPrenotazioni() } });
              } else {
                 this.route.navigate(['Appuntamenti/scelta-servizi-prenotazione'], { state: { isListaPrenotazioni: this.checkListaPrenotazioni() } });
              }

            }
          }
        });
      } else {
        console.error(this.formDatiRichiedente);
        localStorage.removeItem('app');
        alert("Errore, si prega di ripetere la procedura di appuntamento");
        await this.route.navigate(['home']);
      }
    }
  }

  onTour(): any {
    this.joyrideService.startTour({
      steps: ['primoStep', 'secondoStepPrenotazione']
    })
  }
}
